import queryString from 'query-string'
import isEmpty from 'lodash/isEmpty'

export const appendParams = (strInput, params) => {
  const queryParams = !isEmpty(params)
    ? `?${queryString.stringify(params)}`
    : ''
  return `${strInput}${queryParams}`
}

/**
 * this utility function applies query params to a base url
 * @param { string } url - base url with or without query params
 * @param { object } params - additional query params
 * @returns {string} the base url with the resulting query params
 */
export const applyUrlParams = (url, params) => {
  if (!url) return url
  try {
    const { hostname, protocol, pathname, search } = new URL(url)
    const baseUrl = `${protocol}//${hostname}${pathname}`
    return appendParams(baseUrl, {
      ...queryString.parse(search),
      ...params
    })
  } catch (err) {
    return appendParams(url, params)
  }
}

export default applyUrlParams
